import { render, staticRenderFns } from "./SocialAttendanceTypeList.vue?vue&type=template&id=84331b5c&"
import script from "./SocialAttendanceTypeList.js?vue&type=script&lang=js&"
export * from "./SocialAttendanceTypeList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports